// Import Bootstrap's JavaScript
import 'bootstrap';

// Alternatively, you may import plugins individually as needed:
// import 'bootstrap/js/src/util';
// import 'bootstrap/js/src/dropdown';

// main.js

// https://github.com/JacobLett/IfBreakpoint
function checkIfBlock(s) {
	var s = "block" == $(s).css("display");
	return s
}

function checkSize() {
	xs = checkIfBlock(".breakpoint-check .xs"), sm = checkIfBlock(".breakpoint-check .sm"), md = checkIfBlock(".breakpoint-check .md"), lg = checkIfBlock(".breakpoint-check .lg"), xl = checkIfBlock(".breakpoint-check .xl"), console.clear(), 1 == xs && (breakpoint = "xs - <576px", console.log(breakpoint), $("body").removeClass("xs sm md lg xl").addClass("xs")), 1 == sm && (breakpoint = "sm - ≥576px", console.log(breakpoint), $("body").removeClass("xs sm md lg xl").addClass("sm")), 1 == md && (breakpoint = "md - ≥768px", console.log(breakpoint), $("body").removeClass("xs sm md lg xl").addClass("md")), 1 == lg && (breakpoint = "lg - ≥992px", console.log(breakpoint), $("body").removeClass("xs sm md lg xl").addClass("lg")), 1 == xl && (breakpoint = "xl - ≥1200px", console.log(breakpoint), $("body").removeClass("xs sm md lg xl").addClass("xl"))
}
var xs, sm, md, lg, xl, breakpoint;
$(document).ready(function () {
	$("body").append("<div style='display:none;' class='breakpoint-check'><span class='xs d-block d-sm-inline'></span><span class='sm d-sm-block d-md-inline'></span><span class='md d-md-block d-lg-inline'></span><span class='lg d-lg-block d-xl-inline'></span><span class='xl d-xl-block'></span></div>"), checkSize()
}), $(window).resize(function () {
	checkSize()
});



import 'slick-carousel';
import 'howler';
import 'lightcase';

// isotope + webpack c'est un peu différent
// cf : https://isotope.metafizzy.co/extras.html#webpack
var jQueryBridget = require('jquery-bridget');
var Isotope = require('isotope-layout');

// =============================================================================
// Version   : 0.0.1
// Created : Mars 2018
// Project   : WonderStart
// -----------------------------------------------------------------------------
// Core JS
// =============================================================================

/*===================================
=            Global Vars            =
===================================*/
var baseUrl = 'https://ataat.test/',
	baseFontSize = 16;

/*==========================================================
=        Declare Tools & Functions                         =
==========================================================*/

// SVG / PNG Fallback
function svgPngFallback() {
	if (!Modernizr.svg) {
		$('img[src*="svg"]').attr('src', function () {
			return $(this).attr('src').replace('.svg', '.png');
		});
	}
}

function getElementStyleValue(element, property) {
	var value = $(element).css(property).replace("px", "");
	return parseInt(value);
}

//////////////////////////////////////////////////////////
// Set header Site Wrapper height when fixed children 	//
/////////////////////////////////////////////////////////
function setHeaderSiteHeight() {
	var $siteHeader = $('.js-siteHeader');
	$siteHeader.css({
		'height': $siteHeader + 'px'
	});
}

/**
 * Howler audio sound
 */
function setAudio() {
	if ($('#playBtn')) {

		var playBtn = $('#playBtn');
		var pauseBtn = $('#pauseBtn');
		var stopBtn = $('#stopBtn');

		var src = $('#playBtn').data('audio-file');

		var player = new Howl({
			src: [src],
			onplay: function () {
				playBtn.hide();
				pauseBtn.show();
				stopBtn.show();
			},
			onpause: function () {
				playBtn.show();
				pauseBtn.hide();
				stopBtn.hide();
			},
			onstop: function () {
				playBtn.show();
				pauseBtn.hide();
				stopBtn.hide();
			}
		});

		playBtn.show();
		pauseBtn.hide();
		stopBtn.hide();
		// Bind our player controls.
		playBtn.bind('click', function () {
			player.play();
		});
		pauseBtn.bind('click', function () {
			player.pause();
		});
		stopBtn.bind('click', function () {
			player.stop();
		});
	}

}

// Pour afficher un carousel des gallery
function setupTilesCarousel() {
	var $gallery = $('.js-gallery');

	$gallery.each(function () {
		var $customID = $(this).find('.wp-tiles-grid').attr('id');
		var $links = $(this).find('a');
		$links.each(function () {
			$(this).attr('data-rel', 'lightcase:my' + $customID);
			$(this).attr('title', $(this).find('.wp-tiles-byline-title').text());
		})

	})
}
//////////////
// Lightbox //
//////////////
function lightBox() {
	$('a[href$="jpg"], a[href$="png"], a[href$="jpeg"], .js-mediaBox').lightcase({
		maxWidth: 1280,
		maxHeight: 1024,
		slideshow: true,
		slideshowAutoStart: false,
		showCaption: true

	});
}

////////////
// Slider //
////////////
function slider() {
	var $slider = $('.js-slider');

	$slider.slick({
		lazyLoad: 'ondemand',
		dots: false,
		arrows: false,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 1000,
		speed: 500,
		fade: true,
		cssEase: 'linear'
	});
}
/** 
 * gallery (pour single gallery par exemple)
 */
function gallery() {
	var $gallery = $('.gallery');
	$gallery.slick({
		dots: true,
		arrows: true,
		infinite: true,
		speed: 1500,
		autoplay: true,
		autoplaySpeed: 4000,
		fade: true,
		cssEase: 'ease',
		slidesToShow: 3,
		slidesToScroll: 3,
		// prevArrow:"<button type='button' class='o-gallery-prev'><span class='o-Icon'></span></button>",
		// nextArrow:"<button type='button' class='o-gallery-next'><span class='o-Icon'></span></button>",
		responsive: [

			{
				breakpoint: 600,
				settings: {
					arrows: true
				}
			},
			{
				breakpoint: 480,
				settings: {
					arrows: false,
					autoplay: false,
				}
			}
		]
	});
}
/**
 * use child <img> for bgUrl
 */
function imgLiquid() {
	$(".js-imgBkg").imgLiquid({
		fill: true,
		verticalAlign: 'center',
		horizontalAlign: 'center'
	});
}



////////////////////
// sticky footer //
////////////////////
function stickyFooter() {
	var $windowHeight = $(window).height(),
		$footer = $(".js-footerSite"),
		footerPos = $footer.position(),
		contentHeight = $windowHeight - footerPos.top,
		emptySpace = contentHeight - $footer.height();

	if (emptySpace > 0) {
		$footer.css({
			'margin-top': emptySpace / baseFontSize + 'rem'
		});
	}
}

function setFooter() {
	setHeaderSiteHeight();
	//(re)calculate sticky-footer
	stickyFooter();
}

/**
 * Menu full screen mobile
 */
function menuFS() {

	$('.js-Menu-close').on('click', function () {
		$('#site-navigation').toggleClass('toggled');
		$('body').toggleClass('open');
		$('.js-Menu-toggle').toggleClass('is-active');
	});

	$('.js-Menu-toggle').on('click', function () {
		$(this).toggleClass('is-active');
		$('body').toggleClass('open');
	});

}

function textRotator(myarray) {

	var index = randomIntFromInterval(0, myarray.length);
	//var index = 7;
	$('.js-homeTeaser').hide()
	$('.js-homeTeaser-link').text(myarray[index].title);
	$('.js-homeTeaser-link').attr('href', myarray[index].link);
	$('.js-homeTeaser').fadeIn(1000)
	//console.log(myarray);
	// animation option
	var rotate = function () {

		$('.js-homeTeaser').fadeOut(1000, function () {

			if ((index) == myarray.length) index = 0;

			$('.js-homeTeaser-link').text(myarray[index].title);
			$('.js-homeTeaser-link').attr('href', myarray[index].link);


		}).fadeIn(1000);

		index++;
	};

	setInterval(rotate, 8000);

}

function randomIntFromInterval(min, max) {
	return Math.floor(Math.random() * (max - min + 1) + min);
}

/**
 * Isotope
 */
function docFilters() {

	// make Isotope a jQuery plugin
	jQueryBridget('isotope', Isotope, $);

	// // init Isotope
	var $grid = $('.c-document-archive').isotope({
		itemSelector: '.c-document'
	});
	// store filter for each group
	var filters = {};

	// now you can use $().isotope()

	$('.c-Filters').on('click', 'a', function () {
		var $this = $(this);
		// get group key
		var $buttonGroup = $this.parents('.c-Filters');
		var filterGroup = $buttonGroup.attr('data-filter-group');
		// set filter for group
		filters[filterGroup] = $this.attr('data-filter');
		// combine filters
		var filterValue = concatValues(filters);

		// set filter for Isotope
		$grid.isotope({
			filter: filterValue
		});
	});

	// // change is-checked class on buttons
	$('.c-Filters').each(function (i, buttonGroup) {
		var $buttonGroup = $(buttonGroup);
		$buttonGroup.on('click', 'a', function () {
			$('.is-checked').removeClass('is-checked');
			$(this).addClass('is-checked');
		});
	});
	//Clear all 
	$('.c-Filters--all').on('click', 'a', function () {
		$('.is-checked').removeClass('is-checked');
	});
	// flatten object by concatting values
	function concatValues(obj) {
		var value = '';
		for (var prop in obj) {
			value += obj[prop];
		}
		return value;
	}


}

function changeText() {
	$('#link-collapse').find('span').text(function (_, txt) {
		var ret = '';

		if (txt == '+') {
			ret = '-';

		} else {
			ret = '+';
		}
		return ret;
	});
	return false;
}

function toggleText() {
	$('#collapseContent').on('show.bs.collapse', function () {
		console.log('show');
		changeText();
		// do something…

	})
	$('#collapseContent').on('hide.bs.collapse', function () {
		console.log('show');
		changeText();
		// do something…

	})


}
function showDocument(){
	$('.js-document').css('opacity', 1);
	$('.c-document--navigation').css('opacity', 1);
}
function resizeDocument() {
	
	if (xs == true) {
		showDocument();
	}
	// on calcule les tailles seulement si c'est pas du mobile
	if (xs == false) {

		$('.js-document').each(function () {

			var bodyHeight = $('body').height();
			var bodyWidth = $('body').width();

			$('.c-document--header-inner').css('padding', '10%');

			$(this).css('flex', 'unset');
			$(this).css('height', '90%');

			var docHeight = $(this).innerHeight();
			var boxWidth = docHeight / 1.6;

			$(this).css('width', boxWidth);

			$('.c-document--header--number').css('font-size', boxWidth / 2);
			$('.c-document--header--title').css('font-size', boxWidth / 13);

			$('.c-document--content-inner').css({
				fontSize: boxWidth / 21,
				lineHeight: boxWidth / 15 + 'px'
			});
			$('.c-document--more,.c-document--header--meta ul,.c-document--draft').css({
				fontSize: boxWidth / 24,
				lineHeight: boxWidth / 15 + 'px'
			});

			$('.c-document--header--meta ul').css({
				marginTop: boxWidth / 300 + 'rem',
				marginBottom: boxWidth / 300 + 'rem',
				paddingTop: boxWidth / 500 + 'rem',
				paddingBottom: boxWidth / 500 + 'rem'
			});

			$('.c-document--content-inner').css({
				paddingTop: (docHeight / 50) + 'px',
				paddingLeft: boxWidth / 10 + 'px',
				paddingRight: boxWidth / 10 + 'px'
			});
			$('.c-document--header--audio button').css({
				width: boxWidth / 10 + 'px'
			});
			
			showDocument();
		});
	}

}
// function setHeight(){
// 	$('.js-document').each(function(){

// 	}
// }
function setBgImage(){
	var img = $('#uniqueImg');
	if( img ){
		var srcImg = $('#uniqueImg').data('src');
		$('#uniqueImg').attr('style', srcImg);
	}
}
/*===============================================================
=       Main Func: initialize values and call initializers      =
===============================================================*/
function initPage() {


	menuFS();

	setAudio();

	if (typeof jsArray !== 'undefined') {
		textRotator(jsArray);
	}

	resizeDocument();

	setupTilesCarousel();

	// Init lightbox
	lightBox();

	// // img bkg
	// imgLiquid();

	// La super animation en fond de page
	slider();

	//gallery();

	// Trigger resize
	//setFooter();

	//searchFilters();

	//customSelect();
	docFilters();

	toggleText();

	setBgImage();
}

/*==========================================================
=       when adjust/change  window size                    =
==========================================================*/
$(window).on('resize', function () {
	// (re)claculate header-Site when sticky nav
	//setFooter();
	resizeDocument();
});

/*==========================================================
=             init main func (doc ready jquery)            =
==========================================================*/
// IE flexbox polyfill
//flexibility(document.body);

$(document).ready(initPage);


// WEBPACK FOOTER //
// ./src/assets/js/app.js